<template>
  <div class="geo bg-white w-full h-full">
    <GChart
      v-if="chartData.length > 1"
      class="mt-10"
      :type="'GeoChart'"
      :data="chartData"
      :options="chartOptions"
      :settings="settings"
    />
    <div v-else class="p-10 text-4xl text-red-500">
      No data available.
    </div>
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts';

export default {
  name: 'GeoSalesChart',
  data() {
    return {
      settings: {
        packages: ['geochart'],
        mapsApiKey: process.env.VUE_APP_GOOGLE_API_KEY,
      },
    };
  },
  components: {
    GChart,
  },
  computed: {
    chartData() {
      return this.$store.getters['AIGeospatial/getGeoChartData'];
    },

    region() {
      return this.$store.state.AIGeospatial.region;
    },

    chartOptions() {
      return {
        region: this.region,
        displayMode: 'markers',
      };
    },
  },
};
</script>

<style scoped>
  .geo {
    flex: 0 1 58%;
  }
</style>
